import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PaneListEntry from './PaneListEntry'

@inject('auth', 'user')
@observer
export default class PaneListBody extends Component {

  static propTypes = {
    auth: PropTypes.object,
    district: PropTypes.string,
    filter: PropTypes.string,
    user: PropTypes.object,
  }

  render() {

    const {
      user, auth, district, filter
    } = this.props

    const filterNormalized = filter.toLowerCase()

    const districtIsActive = district !== 'all-districts'
      && district !== 'no-district'

    let users = user.collection

    if (filterNormalized) {
      users = users.filter((currUser) => {
        return `${currUser.surname}, ${currUser.firstname}, ${currUser.museum ? currUser.museum.name : ''}`
          .toLowerCase()
          .indexOf(filterNormalized) > -1
      })
    }

    // only show those users that have the same or lower permissions
    users = users.filter((currUser) => auth.acs.isAuthorized(Object.keys(currUser.permissions).join(',')))
    // SUPERADMINS only
    // filter out users by the selected district
      .filter((currUser) => {
        if (district === 'all-districts') {
          return true
        }
        if (district === 'no-district') {
          return !currUser.districtId
        }
        return currUser.districtId * 1 === district * 1
      })

    users = users
      .map((currUser, index) => {

        // sort by group and the surname
        const key = [
          currUser.acs.isAuthorized('ADMIN') ? 'A' : 'B',
          currUser.acs.isAuthorized('SUPERADMIN') ? 'A' : 'B',
          currUser.surname.toUpperCase()
        ].join('')

        return { key, index }
      })
      .sort((a, b) => {
        if (a.key < b.key) return -1
        if (a.key > b.key) return 1
        return 0
      })
      .map((el) => users[el.index])

    const responsibleAdmins = (districtIsActive && users && users.lengh)
      ? users[0].responsibleAdmins
      : null

    return (
      <div className="vertical">
        <div
          className="vertical"
        >

          {responsibleAdmins
            ? (
              <div className="box fixed">
                Verwantwortliche:
                <ul>
                  {responsibleAdmins.map((admin) => (
                    <li key={admin.id}>
                      <a href={`mailto:${admin.email}`}>{admin.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            )
            : null}

          <ul
            className="nav-list v-scrollable vertical"
          >
            {
              users
                .map((currUser) => (
                  <PaneListEntry
                    key={currUser.id}
                    user={currUser}
                  />
                ))
            }

          </ul>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/user/components/PaneListBody.js